'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _ControlLabel = require('react-bootstrap/lib/ControlLabel');

var _ControlLabel2 = _interopRequireDefault(_ControlLabel);

var _FormControl = require('react-bootstrap/lib/FormControl');

var _FormControl2 = _interopRequireDefault(_FormControl);

var _FormGroup = require('react-bootstrap/lib/FormGroup');

var _FormGroup2 = _interopRequireDefault(_FormGroup);

var _HelpBlock = require('react-bootstrap/lib/HelpBlock');

var _HelpBlock2 = _interopRequireDefault(_HelpBlock);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _noop = require('../../utils/noop');

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Input = require('./Input.scss');

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(Input, _Component);

    function Input() {
        (0, _classCallCheck3.default)(this, Input);
        return (0, _possibleConstructorReturn3.default)(this, (Input.__proto__ || (0, _getPrototypeOf2.default)(Input)).apply(this, arguments));
    }

    (0, _createClass3.default)(Input, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['accept', 'autoFocus', 'autoCapitalize', 'autoComplete', 'autoCorrect', 'children', 'className', 'disabled', 'errorMessage', 'help', 'iconClassName', 'id', 'inputClassName', 'label', 'placeholder', 'small', 'type', 'valid', 'value', 'wide']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                accept = _props.accept,
                autoComplete = _props.autoComplete,
                autoCapitalize = _props.autoCapitalize,
                autoCorrect = _props.autoCorrect,
                autoFocus = _props.autoFocus,
                dontRecordForFullstory = _props.dontRecordForFullstory,
                children = _props.children,
                className = _props.className,
                disabled = _props.disabled,
                errorMessage = _props.errorMessage,
                help = _props.help,
                iconClassName = _props.iconClassName,
                id = _props.id,
                inputClassName = _props.inputClassName,
                inputRef = _props.inputRef,
                label = _props.label,
                onBlur = _props.onBlur,
                onChange = _props.onChange,
                onKeyPress = _props.onKeyPress,
                placeholder = _props.placeholder,
                small = _props.small,
                type = _props.type,
                valid = _props.valid,
                value = _props.value,
                wide = _props.wide;


            var validationState = valid ? {} : { validationState: 'error' };
            var componentClass = type === 'select' ? { componentClass: 'select' } : {};
            componentClass = type === 'textarea' ? { componentClass: 'textarea' } : componentClass;

            var errorComponents = [(0, _jsx3.default)(_FormControl2.default.Feedback, {
                className: _Input2.default['custom-error-icon'] + ' ' + iconClassName,
                bsClass: 'form-control-feedback custom-error-icon'
            }, 0), (0, _jsx3.default)('div', {
                className: _Input2.default.error
            }, 1, errorMessage)];

            var classes = (0, _classnames2.default)(_Input2.default['form-group'], className, (_classNames = {}, (0, _defineProperty3.default)(_classNames, _Input2.default.small, small), (0, _defineProperty3.default)(_classNames, _Input2.default.wide, wide), _classNames), className);

            var inputClasses = (0, _classnames2.default)(_Input2.default['form-control'], inputClassName, (0, _defineProperty3.default)({}, _Input2.default.recordingExclude, dontRecordForFullstory));
            var pattern = type === 'number' ? '\\d*' : '';

            return _react2.default.createElement(
                _FormGroup2.default,
                (0, _extends3.default)({ className: classes, controlId: id }, validationState),
                !!label && (0, _jsx3.default)(_ControlLabel2.default, {}, void 0, label),
                !!help && (0, _jsx3.default)(_HelpBlock2.default, {}, void 0, help),
                _react2.default.createElement(
                    _FormControl2.default,
                    (0, _extends3.default)({
                        accept: accept,
                        autoComplete: autoComplete ? 'on' : 'off',
                        autoCapitalize: autoCapitalize ? 'on' : 'off',
                        autoCorrect: autoCorrect ? 'on' : 'off',
                        autoFocus: autoFocus,
                        className: inputClasses,
                        disabled: disabled,
                        inputRef: inputRef,
                        onChange: onChange,
                        onBlur: onBlur,
                        onKeyPress: onKeyPress,
                        placeholder: placeholder,
                        type: type,
                        pattern: pattern,
                        value: value
                    }, componentClass),
                    children
                ),
                !valid && errorComponents
            );
        }
    }]);
    return Input;
}(_react.Component), _class.defaultProps = {
    accept: '*',
    autoCapitalize: true,
    autoComplete: true,
    autoCorrect: true,
    className: '',
    disabled: false,
    iconClassName: '',
    inputClassName: '',
    inputRef: _noop2.default,
    onBlur: _noop2.default,
    onChange: _noop2.default,
    onKeyPress: _noop2.default,
    placeholder: '',
    small: false,
    type: 'text',
    valid: true
}, _temp);
exports.default = Input;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Input/Input.js
// module id = Alk2
// module chunks = 57